import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowseRoutingModule } from './browse-routing.module';
import { BrowseComponent } from './browse.component';
import { BrowseTableComponent } from './browse-table/browse-table.component';
import { BrowseTablePagingComponent } from './paging/paging.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared/shared.module';
import { LegacyStaffModule } from '../../modules/shared/staff/legacy-staff.module';
import { DirectiveModule } from '../../shared/directives/directive.module';

@NgModule({
  declarations: [BrowseComponent, BrowseTableComponent, BrowseTablePagingComponent],
  imports: [
    CommonModule,
    SharedModule,
    BrowseRoutingModule,
    NgbModule,
    LegacyStaffModule,
    DirectiveModule,
  ],
})
export class BrowseModule {}
